<template>
  <div class="groups-container">
    <b-row align-v="start">
      <b-col cols="12" lg="12" md="12" sm="12" xs="12" class="mb-3" v-for="group in groups" :key="group.id">
        <ul class="list-unstyled">
          <MembersMedia v-bind:group="group"></MembersMedia>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MembersMedia from './MembersMedia'
export default {
  name: 'groups',
  props: {
    'groups': Array
  },
  components: {
    MembersMedia
  }
}
</script>

<style>
  .group-container {
    border: 1px solid #eeeff0;
    min-width: 240px
  }
</style>



// WEBPACK FOOTER //
// src/components/groups/MembersList.vue